import './personDetection.less';
import Detection from './detection.js';
export default class PersonDetection extends Detection
{

    get renderer()
    {
        //language=HTML
        return /*html*/`
    		<li pf="item">
                <a href="" class=" item-content item-link" pf="link">
                    <div class="item-inner">
                        <table class="detection-table">
                            <tr>
                                <td class="similarity"> 
                                    <span title="similarity">@{model.similarityPercent}</span> 
                                </td>
                                <td class="detection-img">
                                    <div class="img">
                                        <img src="@{model.personImgsTitle}" pf="img"><br/>
                                    </div>
                                </td>
                                <td class="time"> <span class="span"> @{model.startMsc}</span> </td>
                                <td class="server-va"> <span class="span"> @{model.camera.serverVa.name}</span> </td>
                                <td class="camera"> <span class="span"> @{model.camera.name}</span> </td>
                                <td class="emotion"> 
                                    <span pf="emotion" title="Преобладающая эмоция">@{model.emotion.name}</span> 
                                    <span pf="emotionPercent" title="Среднее значение преобладающей эмоции">@{model.emotionPercent}</span>
                                </td>
                                <td class="has-screen"> <span pf="hasScreenViewText">@{model.hasScreenViewText}</span> </td>
                                <td class="process"> <span pf="processText">@{model.processText}</span>  </td>
                            </tr>     
                        </table>
                    </div>
    			</a>
    		</li>
    	`;
    }

    onRender()
    {
        this.model.personImgsTitle = '';
        if (this.model.personImgs[0] !== undefined) {
            this.model.personImgsTitle = this.model.personImgs[0].file.local_url
        }
        super.onRender();

    } // onRender

    linkPerson() {
        this.person_link = false;
        this.bindDom({ linkPerson: 'show' }, 'person_link');
    }
}